import { Holiday } from 'domain/Holiday';
import { ActionFactory } from '../types';
import {
  ActionType, SetHolidayListLoadingAction, AddHolidayAction, UpdateHolidayAction,
  RemoveHolidayAction, RefreshHolidayListAction,
} from './types';

export const setIsHolidayListLoading: ActionFactory<boolean, SetHolidayListLoadingAction> = (isLoading) => ({
  type: ActionType.SET_HOLIDAY_LIST_LOADING,
  isLoading,
});

export const addHoliday: ActionFactory<Holiday, AddHolidayAction> = (newHoliday) => ({
  type: ActionType.ADD_HOLIDAY,
  holiday: newHoliday,
});

export const removeHoliday: ActionFactory<Holiday, RemoveHolidayAction> = (deletedHoliday) => ({
  type: ActionType.REMOVE_HOLIDAY,
  holiday: deletedHoliday,
});

export const updateHoliday: ActionFactory<Holiday, UpdateHolidayAction> = (updatedHoliday) => ({
  type: ActionType.UPDATE_HOLIDAY,
  holiday: updatedHoliday,
});

export const refreshHolidayList: ActionFactory<Holiday[], RefreshHolidayListAction> = (newHolidayList) => ({
  type: ActionType.REFRESH_HOLIDAY_LIST,
  holidayList: newHolidayList,
});
